import { useNavigate } from "react-router-dom";
import React from "react";
import ManageAgreements from "us.collection/components/ManageAgreements/ManageAgreements";

interface ICnt_Agreements {
  caseNo: number;
}

const Cnt_Agreements: React.FC<ICnt_Agreements> = (props) => {

  const onMinimize = () => {
    const navigate = useNavigate();
    navigate(`/case/${props.caseNo}`);
  };

  return <ManageAgreements onMinimize={() => onMinimize()} {...props} />;
};

export default Cnt_Agreements;
